import { getStrWithoutSpaces } from 'legacy/lut/components/widgets/public/partner360/helpers/getStrWithoutSpaces'
import { IProgramType } from 'legacy/lut/features/partner360/configuration'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Switch } from 'core-components/library/checkbox'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './OfferingSwitcher.module.scss'

export interface IOfferingChange {
  flag: boolean
  offering: IProgramType
}

interface IProps {
  offering: IProgramType
  index: number
  isTooltipDisabled?: boolean
  isToggleDisabled?: boolean
  availableProgramTypes: IProgramType[]
  onToggle: (data: IOfferingChange) => void
}

export const OfferingSwitcher = ({
  offering,
  isToggleDisabled = false,
  isTooltipDisabled = false,
  index,
  availableProgramTypes,
  onToggle,
}: IProps) => {
  return (
    <Tooltip
      key={offering.programType}
      disabled={isTooltipDisabled}
      className={styles.specializationEditorItem}
      tipContent={() => (
        <Translation text="jbp-partner-program-types-last-specialization" actionsInside />
      )}
    >
      <Switch
        className={styles.specializationEditorItem}
        label={
          <Translation text={`jbp-partner-type-${getStrWithoutSpaces(offering.programType)}`} />
        }
        checked={offering.enabled}
        onChange={(flag) => onToggle({ flag, offering })}
        disabled={isToggleDisabled}
        margin={index < availableProgramTypes.length - 1 ? 'md' : undefined}
      />
    </Tooltip>
  )
}
